import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import Calendar from './Calendar';

import { toAbsoluteUrl } from '../../_ens/_helpers';
import { getAdminSettings } from '../modules/Admin/AdminActions';
import { KTUtil } from '../../_ens/_assets/js/components/util';
import IphoneModel from '../modules/Auth/pages/IphoneModel';

import VideoNotAvailableIphoneModel from '../modules/Auth/pages/VideoNotAvailableIphoneModel';
import '../modules/STAI2/styles/DashboardSTAI2.scss';
import { getAllProjects } from '../services/projects.service';

export const Wrapper = ({ auth, history }) => {
  const [showModal, setShowModal] = useState(false);
  const [showSTAI2Modal, setShowSTAI2Modal] = useState(false);
  const [disableVideo, setDisableVideo] = useState(true);
  const [modalIphoneShow, setModelIphoneShow] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);

  const onModelIphoneHide = () => {
    setModelIphoneShow(false);
  };

  useEffect(() => {
    if (KTUtil.isIphoneDevice()) {
      setModelIphoneShow(true);
    }
    getAdminSettings().then((res) => {
      setDisableVideo(res.data.disableVideo);
    });

    // Recupera i progetti dinamicamente (interpreti con id, utenti senza)
    if (auth.user.role === 'Interpreter' || auth.user.role === 'User') {
      setLoadingProjects(true);
      getAllProjects(auth.user.role === 'Interpreter' ? auth.user.id : undefined)
        .then((res) => {
          setProjects(res.data || []);
        })
        .catch((err) => {
          console.error('Errore nel caricamento dei progetti:', err);
          setProjects([]);
        })
        .finally(() => {
          setLoadingProjects(false);
        });
    }
  }, [auth.user.role]);

  const onCall = () => {
    if (auth.user.role === 'User') {
      history.push('/call');
    } else {
      history.push('/interpreter/call');
    }
  };

  const goToSTAI2VideoCalls = (projectId) => {
    setProjectId(projectId);
    setShowSTAI2Modal(true);
  };

  const onSTAI2Call = () => {
    setShowSTAI2Modal(false);
    if (auth.user.role === 'Interpreter') {
      history.push('/guest-call?interpreterId=' + auth.user.id + '&projectId=' + projectId);
    } else {
      history.push('/stai2/call?projectId=' + projectId);
    }
  };

  const stai2Projects = projects.filter((project) => {
    if (!project.is_active) {
      return false;
    }

    if (auth.user.role === 'Interpreter') {
      return Number(project.id) >= 2;
    }

    return Number(project.id) === 2 || project.code === 'STAI2';
  });
  const hasSTAI2 = stai2Projects.length > 0;
  const useThreeColumns =
    auth.user.role === 'Interpreter' || (auth.user.role === 'User' && hasSTAI2);

  return (
    <>
      {auth.user.role === 'Admin' || disableVideo ? (
        <Calendar />
      ) : (
        <>
          <div className="container" style={{ maxWidth: '100%', padding: 0 }}>
            <div className="row mb-10">
              <div className="col-md-12 text-center" style={{ fontSize: '40px' }}>
                Scegli un servizio di interpretariato LIS
              </div>
            </div>
            <div className={`row pl-30 pr-30 ${useThreeColumns ? 'three-columns' : ''}`}>
              {/* SEZIONI PROGETTI DINAMICHE - Per interpreti e utenti */}
              {stai2Projects.map((project) => (
                <div key={project.id} className="col-md-4 d-flex my-2">
                  <div className="sn_right_section d-flex flex-grow-1 h-100">
                    <div className="sn_content" onClick={() => goToSTAI2VideoCalls(project.id)}>
                      <img
                        src={project.logo ? project.logo : toAbsoluteUrl('/media/logos/csb.png')}
                        style={{ maxWidth: '100%' }}
                        alt={`${project.name} icon`}
                      />
                      <br />
                      {project.name}
                      <br />
                      {project.description || 'SERVIZIO TURISTICO'}
                    </div>
                  </div>
                </div>
              ))}
              {(projects.filter((p) => p.code === 'CSB').length > 0 ||
                auth.user.role === 'User') && (
                <>
                  <div className={`${useThreeColumns ? 'col-md-4' : 'col-md-6'} d-flex my-2`}>
                    <div
                      className="d-flex flex-grow-1 h-100 sn_left_section"
                      style={{ opacity: 0.4 }}
                    >
                      <div
                        className="sn_content"
                        /* WARN: REMOVE COMMENT AND OPACITY STYLE TO ENABLE ONSITE SERVICE
                      onClick={() =>
                      history.push(
                        auth.user.role === 'User' ? '/calendar' : '/Interpreter/calendar'
                      )
                    }*/
                      >
                        <img
                          src={toAbsoluteUrl('/media/image/onsite.png')}
                          style={{ maxWidth: '100%' }}
                          alt={'onsite image icon'}
                        />
                        <br />
                        Interpretariato su Prenotazione
                        <br />
                        in Presenza e a Distanza
                      </div>
                    </div>
                  </div>
                  <div className={`${useThreeColumns ? 'col-md-4' : 'col-md-6'} d-flex my-2`}>
                    <div className="d-flex flex-grow-1 h-100 w-100 sn_right_section">
                      <div className="sn_content" onClick={() => setShowModal(true)}>
                        <img
                          src={toAbsoluteUrl('/media/logos/csb.png')}
                          style={{ maxWidth: '140px', alignSelf: 'center' }}
                          alt={'online image icon'}
                        />
                        CSB
                        <br />
                        Chiamata Diretta
                        <br />
                        Senza Prenotazione
                        <br />
                        (Call center)
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {modalIphoneShow ? (
            <VideoNotAvailableIphoneModel
              center={true}
              show={modalIphoneShow}
              onHide={onModelIphoneHide}
            />
          ) : (
            ''
          )}

          <Modal
            show={showModal}
            onHide={() => setShowModal(!showModal)}
            dialogClassName="modal-dialog-centered modal-90w"
          >
            <Modal.Body className="text-center">
              <h4>Vuoi iniziare la Videochiamata?</h4>
              <div className="confirm-btn">
                <Button variant="primary" className="mr-2" onClick={() => onCall()}>
                  Prosegui
                </Button>
                <Button variant="danger" onClick={() => setShowModal(!showModal)}>
                  Annulla
                </Button>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={showSTAI2Modal}
            onHide={() => setShowSTAI2Modal(!showSTAI2Modal)}
            dialogClassName="modal-dialog-centered modal-90w"
          >
            <Modal.Body className="text-center">
              <h4>Vuoi iniziare il servizio STAI 2?</h4>
              <p className="text-muted mb-4">Servizio Turistico di Assistenza Interpretariato</p>
              <div className="confirm-btn">
                <Button variant="primary" className="mr-2" onClick={() => onSTAI2Call()}>
                  Prosegui
                </Button>
                <Button variant="danger" onClick={() => setShowSTAI2Modal(!showSTAI2Modal)}>
                  Annulla
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps)(Wrapper);
